import React from 'react';

export const CrashMessageContainer: React.FC = props => (
  <div className="crash__container" {...props} />
);
